import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlsEnum } from '@lib/enums';
import {
  IBotHistoryFilter,
  IChatMessagesFilter,
  IFilterBase,
  IHelpRequestMessage,
  IMessageBody,
  HelpRequestInterface,
} from '@lib/interfaces';
import { IBotHistoryMessage } from '@lib/interfaces/bot-history-message.interface';
import { httpParamsUtil } from '@lib/utils';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StateService } from './state.service';
import {GetMessagesDto} from '@app/pages/messenger/get-messages.dto';
import {HelpRequestsQueryDto} from "@core/dto/requests/help-requests-query.dto";

@Injectable({
  providedIn: 'root'
})
export class HelpDataService {

  constructor(
    private readonly http: HttpClient,
    private readonly stateService: StateService,
  ) { }

  public getCustomers(dto?: HelpRequestsQueryDto): Observable<Array<HelpRequestInterface>> {
    const params = httpParamsUtil(dto || {});

    return this.http.get<Array<HelpRequestInterface>>(`${environment.host}${ApiUrlsEnum.help}`, { params });
  }

  public getCustomerById(id: number): Observable<HelpRequestInterface> {
    return this.http.get<HelpRequestInterface>(`${environment.host}${ApiUrlsEnum.help}/${id}`);
  }

  public markMessagesAsRead(id: number): Observable<void> {
    return this.http.patch<void>(`${environment.host}${ApiUrlsEnum.help}/${id}`, null);
  }

  public getMessageList(userId: number, dto?: GetMessagesDto): Observable<Array<IHelpRequestMessage>> {
    const params = httpParamsUtil(dto);
    return this.http.get<Array<IHelpRequestMessage>>(`${environment.host}/api/help/${userId}/messages`, { params });
  }

  public sendMessage(formData: FormData): Observable<IHelpRequestMessage> {
    return this.http.post<IHelpRequestMessage>(`${environment.host}${ApiUrlsEnum.helpSendMessage}`, formData);
  }

  public getBotHistory(filter: Partial<IBotHistoryFilter>): Observable<Array<IBotHistoryMessage>> {
    const params = httpParamsUtil(filter);

    return this.http.get<Array<IBotHistoryMessage>>(`${environment.host}${ApiUrlsEnum.help}/${filter.userId}/botHistory`, { params });
  }

  public getUnreadMessagesCount(): Observable<number> {

    return this.http.get<number>(`${environment.host}${ApiUrlsEnum.unreadCount}`);
  }

  public discountMessages(unreadCount: number): void {
    const count = this.stateService.hasUnreadMessages.value;
    if (unreadCount > count) {
      this.stateService.hasUnreadMessages.next(0);
    } else {
      this.stateService.hasUnreadMessages.next(count - unreadCount);
    }
  }
}
